export default {
  config() {
    let VUE_APP_SERVER = ""; //埋点域名

    const curHost = window.location.host;
    //本地 和 测试
    if (curHost.includes("localhost") || curHost.includes("turboradio.cn")) {
      VUE_APP_SERVER = "https://dataetc.turboradio.cn/sa.php?project=uniondrug";
    }
    //预发布
    if (curHost.includes("uniondrug.net")) {
      VUE_APP_SERVER = "https://dataetc.uniondrug.net/sa.php?project=uniondrug";
    }
    //生产
    if (curHost.includes("uniondrug.cn")) {
      VUE_APP_SERVER = "https://dataetc.uniondrug.cn/sa.php?project=uniondrug";
    }

    return {
      VUE_APP_SERVER
    };
  }
};

